import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Load runtime config (appsettings.json) before rendering
// This allows changing API URL without rebuilding the frontend
const bootstrap = async () => {
  try {
    const res = await fetch('/appsettings.json', { cache: 'no-store' });
    if (res.ok) {
      const json = await res.json();
      (window as any).__CONFIG__ = (window as any).__CONFIG__ || {};
      const apiUrl = json?.Api?.BaseUrl as string | undefined;
      if (apiUrl) {
        (window as any).__CONFIG__.API_URL = apiUrl;
      }
    }
  } catch {
    // Ignore and proceed with defaults
  } finally {
    renderApp();
  }
};

bootstrap();
